module.exports = __webpack_public_path__ + "img/newLogo.822f9f77.png";